import { render, staticRenderFns } from "./SmTextarea.vue?vue&type=template&id=96fb6c80&scoped=true&"
import script from "./SmTextarea.vue?vue&type=script&lang=ts&"
export * from "./SmTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./SmTextarea.vue?vue&type=style&index=0&id=96fb6c80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fb6c80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
